import React, { useState } from 'react';
import {
  ProfileDataItem,
  AddValue,
} from 'pages/Profile/components/ProfileDataItem/ProfileDataItem';
import Label from 'components/form/Label/Label';
import { IncomeForm } from './IncomeForm';
import useIncomeInput from 'pages/Profile/pages/ProfileOverview/hooks/useIncomeInput';
import useDirtyData from 'pages/Profile/pages/ProfileOverview/hooks/useDirtyData';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { formatIncome } from 'helpers/money.helper';

export const Income = ({ annualIncome, saveData, fullWidth, ...props }) => {
  const [isEdit, setIsEdit] = useState(false);
  const annualIncomeInput = useIncomeInput(annualIncome);
  const dirtyData = useDirtyData({});
  const editEnabled = annualIncome && !props.readOnly && !props?.isTestUser;

  const { Title, DisplayView, EditView } = ProfileDataItem;

  function onSaveHandle(e) {
    e.preventDefault();
    props.eventHandler(CLICK, { 'Click Type': 'Save Income Update' });
    saveData({ ...dirtyData.data, incomeSource: 'PROFILE' }).then(() => {
      setIsEdit(false);
    });
  }

  function onEditHandle(e) {
    e.preventDefault();
    props.eventHandler(CLICK, { 'Click Type': 'Edit Income' });
    setIsEdit(true);
  }

  function onCancelHandle(e) {
    e.preventDefault();
    props.eventHandler(CLICK, { 'Click Type': 'Cancel Income Update' });
    setIsEdit(false);
    annualIncomeInput.update(annualIncome);
  }

  function onChangeIncome(e) {
    const { value } = e.target;
    if (/([+\-a-zA-Z;\\`~.@#!&*(){}><^%/'"=:\s[\]_|])/g.test(value)) {
      return false;
    } else {
      annualIncomeInput.update(value);

      dirtyData.processDirtyData(
        'annualIncome',
        annualIncomeInput.trimIncome(value),
        annualIncome.toString(),
      );
    }
  }

  const rndannualIncome = () => {
    if (annualIncome) {
      return <Label className="text-16">{formatIncome(annualIncome)}</Label>;
    }
    return '';
  };

  return (
    <ProfileDataItem datatestid="profileIncome">
      <Title datatestid="incomeLabel">Annual income</Title>
      {!isEdit && (
        <>
          <DisplayView editHandle={onEditHandle} editEnabled={editEnabled}>
            {rndannualIncome()}
            {!annualIncome && (
              <AddValue label="annual income" setIsEdit={setIsEdit} />
            )}
          </DisplayView>
          {/* {canEdit && <EditValue setIsEdit={setIsEdit} />} */}
        </>
      )}
      {isEdit && (
        <EditView
          onCancelHandle={onCancelHandle}
          onSaveHandle={onSaveHandle}
          disabled={
            !!annualIncomeInput.annualIncome.error || dirtyData.isEmpty()
          }
        >
          <IncomeForm
            incomeInput={annualIncomeInput.annualIncome}
            onChangeIncome={onChangeIncome}
            isOptional
            fullWidth={fullWidth}
          />
        </EditView>
      )}
    </ProfileDataItem>
  );
};
